import React, { useState, useEffect } from "react";
import { Box, Grid, TextField, FormControl, InputLabel, Select, MenuItem,
         Checkbox, FormControlLabel, Typography, Button, Switch, Divider,
         Paper,
         FormHelperText,
} from "@mui/material";
import { get, post } from "src/services/httpClient.service";
import { useSnackbar } from "src/components/snackbar/useSnackbar";
import { authenticationService } from "src/services/authentication.service";
import { useNavigate } from "react-router";


const AddOwner: React.FC = () => {
  const navigate = useNavigate()
 
  const [formData, setFormData] = useState({
    location: "",companyId: null, role: null, operatorName: "", email: "", password: "", mobile: "",
    phone: "", address1: "", address2: "", address3: "", postalCode: "", country: "India",
    state: "", zone: "", city: "", franchisees: [] as string[], selectAll: false,
    enableFreeAccess: false, allowNstvIrdCondition: false, allowLowBalanceRecharge: false, status: true,
    roleIdsList: [] as string[], franchiseIdsList: [] as string[], vendorId: null, franchiseId: null,IsOwnerAccount:true
  });

  const APIURL = process.env.REACT_APP_BASE_API_URL;

  const [vendorsList, setVendors] = useState([]);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [states, setStates] = useState<string[]>([]);
  const [cities, setCities] = useState<string[]>([]);
  const [loadingCities, setLoadingCities] = useState(false);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const franchiseeList = ["Franchisee A", "Franchisee B", "Franchisee C", "Franchisee D"];
  const [locations, setLocations] = useState<any[]>([]);
  
  const { showSnackbar } = useSnackbar();
  //const {vendorId, franchiseId} = authenticationService.getVendorFranchiseIds();
  //const [companiesList, setCompanies] = React.useState([]);
  //const [franchiseList, setFranchisees] = React.useState([]);
  //const [rolesList, setRoles] = React.useState([]);



   // Fetch all states on load
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await get(`${APIURL}/states`);
        setStates(response || []);
      } catch (error) {
        console.error("Error fetching states:", error);
      }
    };
    fetchStates();
    fetchVendors();
  }, []);

  const fetchLocations = async (vendorId: string) => {
  if (!vendorId) {
    setFormData((prev) => ({ ...prev, location: "" }));
    return;
  }

  try {
    const res = await get(
      `${APIURL}/api/miscellaneous/area/vendor/${vendorId}/findAll`
    );

    const data = res?.data || res || [];

    if (data.length > 0) {
      const item = data[0];

      const locationString = `${item.name} / ${item.cityName} / ${item.stateName} / ${item.countryName} / ${item.zipCode || item.zip_code || ''}`;

      setFormData((prev) => ({
        ...prev,
        location: locationString
      }));
    } else {
      setFormData((prev) => ({ ...prev, location: "" }));
    }
  } catch (error) {
    console.error("Error fetching locations:", error);
  }
};

useEffect(() => {
  if (formData.vendorId) {
    fetchLocations(formData.vendorId);
  }
}, [formData.vendorId]);

  // Fetch cities based on selected state
  useEffect(() => {
    if (!formData.state) return;
    const fetchCities = async () => {
      setLoadingCities(true);
      try {
        const response = await get(`${APIURL}/cities?stateName=${formData.state}`);
        setCities(response || []);
      } catch (error) {
        console.error("Error fetching cities:", error);
        setCities([]);
      } finally {
        setLoadingCities(false);
      }
    };
    fetchCities();
  }, [formData.state]);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    let tempErrors: { [key: string]: string } = {};

    if (!formData.vendorId) tempErrors.vendorId = "Vendor is required";
    //if (!formData.role) tempErrors.role = "Role is required";
    if (!formData.operatorName.trim()) tempErrors.operatorName = "Name is required";
   
    if (!formData.email) tempErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.email)) tempErrors.email = "Enter a valid email";
    if (!formData.password) tempErrors.password = "Password is required";
    else if (formData.password.length < 6) tempErrors.password = "Password must be at least 6 characters";
    //if (formData.roleIdsList.length === 0) tempErrors.roleIdsList = "Select at least one role";

    // if (formData.franchiseIdsList.length === 0) tempErrors.franchiseIdsList = "Select at least one franchise";

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return; // stop submit if invalid

    console.log("✅ Submitted data:", formData);

    try {
      //formData.vendorId = vendorId;
      //formData.franchiseId = franchiseId;
      const response = await post(`${APIURL}/api/operators/createOwnerAccount`, formData);
      console.log('response',response)

      if(response?.statusCode=="200") {
        showSnackbar("Added Successfully", "success");
        navigate('/modules/OwnerAccounts')
      } else {
        showSnackbar("Added Successfully", "success");
      }
    } catch (error) {
      console.error("Error fetching franchisees:", error);
      showSnackbar(error?.response?.data?.message, "error");
    }

    
  };

  const handleCancel = () => {
    setFormData({
      location: "",companyId: null, role: null, operatorName: "", email: "", password: "", mobile: "",
      phone: "", address1: "", address2: "", address3: "", postalCode: "",
      country: "India", state: "", zone: "", city: "", franchisees: [],
      selectAll: false, enableFreeAccess: false, allowNstvIrdCondition: false,
      allowLowBalanceRecharge: false, status: true, franchiseIdsList: [], roleIdsList: [], vendorId: null, franchiseId: null,
      IsOwnerAccount:true
    });
     navigate('/modules/OwnerAccounts')
   
  };

  const handleSwitchChange = (e: any) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({ ...prev, [name]: checked }));
  };

    // 🔹 Fetch Vendors (handles XML or JSON)
    const fetchVendors = async () => {
      try {
        const response = await get(`${APIURL}/api/vendors`);
  
        setVendors(response);
        console.log('vendoers',vendorsList)
      } catch (err) {
        console.error('Error fetching vendors:', err);
        setError('Failed to load vendors.');
      }
    };

  return (
   <>
   <Box sx={{padding:'20px'}}>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Add New Owner
      </Typography>

      <Grid container spacing={2}>
        
        <Grid item xs={12} md={4}>
          <FormControl fullWidth  error={!!errors.vendorId}>
            <InputLabel id="vendor-label">Vendor</InputLabel>
            <Select
              labelId="vendor-label"
              name="vendorId"
              value={formData.vendorId}
              label="Vendor"
              onChange={handleChange}
            >
              {vendorsList.map((vendor) => (
                <MenuItem key={vendor.vendorId} value={vendor.vendorId}>
                  {vendor.vendorName}
                </MenuItem>
              ))}
            </Select>
            {errors.vendorId && <FormHelperText>{errors.vendorId}</FormHelperText>}
          </FormControl>
        </Grid>

        <Grid item xs={12} md={4}>
           <TextField
            label="Name"
            name="operatorName"
            fullWidth
            value={formData.operatorName}
            onChange={handleChange}
            error={!!errors.operatorName}
            helperText={errors.operatorName}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField label="Phone" name="phone" fullWidth value={formData.phone} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField label="Email" name="email" fullWidth value={formData.email} onChange={handleChange} error={!!errors.email}  helperText={errors.email}/>
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField label="Password" name="password" type="password" fullWidth value={formData.password} onChange={handleChange} error={!!errors.password} helperText={errors.password} />
        </Grid>

        {/* <Grid item xs={12} md={4}>
          <TextField label="Mobile" name="mobile" fullWidth value={formData.mobile} onChange={handleChange} />
        </Grid> */}
        
        {/* Address Info */}
        {/* <Grid item xs={12} md={4}>
          <TextField label="Address 1" name="address1" fullWidth value={formData.address1} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField label="Address 2" name="address2" fullWidth value={formData.address2} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField label="Address 3" name="address3" fullWidth value={formData.address3} onChange={handleChange} />
        </Grid> */}

        {/* <Grid item xs={12} md={3}>
          <FormControl fullWidth error={!!errors.country}>
            <InputLabel>Country</InputLabel>
            <Select name="country" value={formData.country} onChange={handleChange}>
              <MenuItem value="India">India</MenuItem>
            </Select>
            {errors.country && <FormHelperText>{errors.country}</FormHelperText>}
          </FormControl>
        </Grid> */}

        {/* <Grid item xs={12} md={4}>
           <FormControl fullWidth error={!!errors.state}>
            <InputLabel>State</InputLabel>
            <Select name="state" value={formData.state} onChange={handleChange}>
              {states.length > 0 ? (
                states.map((state) => (
                  <MenuItem key={state} value={state}>
                    {state}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No States Found</MenuItem>
              )}
            </Select>
            {errors.state && <FormHelperText>{errors.state}</FormHelperText>}
          </FormControl>
        </Grid> */}

       {/*  <Grid item xs={12} md={3}>
          <FormControl fullWidth error={!!errors.city}>
            <InputLabel>City</InputLabel>
            <Select
              name="city"
              value={formData.city}
              onChange={handleChange}
              disabled={!formData.state || loadingCities}
            >
              {loadingCities ? (
                <MenuItem disabled>Loading...</MenuItem>
              ) : cities.length > 0 ? (
                cities.map((city) => (
                  <MenuItem key={city} value={city}>
                    {city}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No Cities Found</MenuItem>
              )}
            </Select>
            {errors.city && <FormHelperText>{errors.city}</FormHelperText>}
          </FormControl>
        </Grid> */}

        {/* <Grid item xs={12} md={3}>
          <FormControl fullWidth error={!!errors.zone}>
            <InputLabel>Zone</InputLabel>
            <Select name="zone" value={formData.zone} onChange={handleChange}>
              <MenuItem value="North">North</MenuItem>
              <MenuItem value="South">South</MenuItem>
              <MenuItem value="East">East</MenuItem>
              <MenuItem value="West">West</MenuItem>
              <MenuItem value="Central">Central</MenuItem>
              <MenuItem value="North-East">North-East</MenuItem>
              <MenuItem value="North-West">North-West</MenuItem>
              <MenuItem value="South-East">South-East</MenuItem>
              <MenuItem value="South-West">South-West</MenuItem>
            </Select>
            {errors.zone && <FormHelperText>{errors.zone}</FormHelperText>}
          </FormControl>
        </Grid> */}

        <Grid item xs={12} md={4}>
 <TextField
  label="Area (City)"
  name="location"
  fullWidth
  value={formData.location}
  InputProps={{ readOnly: true }}
/>
</Grid>
            
        

        

        {/* <Grid item xs={12} md={3}>
          <TextField label="Postal Code" name="postalCode" fullWidth value={formData.postalCode} onChange={handleChange} />
        </Grid> */}

        {/* Switches */}
        <Grid item xs={12} md={3}>
          <FormControlLabel
            control={<Switch checked={formData.status} onChange={handleSwitchChange} name="status" />}
            label="Status (Active)"
          />
        </Grid>

        {/* Buttons */}
        <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
          <Button variant="contained" color="primary" sx={{ mr: 2 }} onClick={handleSubmit}>
            Save
          </Button>
          <Button variant="outlined" color="secondary" onClick={handleCancel}>
            Cancel
          </Button>
        </Grid>
      </Grid>
      </Box>
    </>
  );
};

export default AddOwner;
